import React from 'react';
import axios from 'axios';
import { toast } from 'bulma-toast';
import server from '../../../../utilities/server';

const CategoryIcon = ({ modal, setModal, refetch, category }) => {

  const [icon, setIcon] = React.useState(null);
  const [iconData, setIconData] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const _selectIcon = (icon) => {
    setIcon(icon.target.files[0]);
  }
  const _deselectIcon = () => {
    setIcon(null);
  }

  const ShowIcon = () => {
    if (!iconData) { return null; }
    return (
      <div id='icon' className='has-text-centered p-3'>
        <a className='delete' aria-label='close' onClick={_deselectIcon}></a>
        <img src={iconData} style={{ maxWidth: 150, maxHeight: 150, }} /><br />
        {
          category.icon && typeof category.icon === 'string' ? <a className='button is-danger' onClick={_deleteIcon} style={loading ? { PointerEvent: 'none' } : null}>حذف الأيقونة</a> : null
        }
      </div>
    )
  }

  const _deleteIcon = async () => {
    setLoading(true);
    try {
      await axios.delete(`http://localhost:3003/admin/media/category-icon/${category.id}`, { params: { name: category.icon, } });
      toast({ type: 'is-success', position: 'center', message: 'تم حذف الأيقونة بنجاح', });
      setIconData(null);
      setLoading(false);
    } catch (_) {
      setLoading(false);
      toast({ type: 'is-danger', position: 'center', message: 'خطأ أثناء حذف الأيقونة', });
    }
  }

  const _getIcon = async () => {
    if (category.icon) {
    const icon = await axios.get('http://localhost:3003/admin/media/category-image', { params: { name: category.icon, }, responseType: 'blob', });
    setIconData(URL.createObjectURL(icon.data));
    } else {
      setIconData(null);
    }
  }

  const _submit = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append('icon', icon);
    formData.append('resize', false);
    server({
      method: 'put',
      path: `categories/icon/${category.id}`,
      data: formData,
    }).then((updateCategory) => {
      console.log(updateCategory)
      toast({ type: 'is-success', position: 'center', message: 'تم رفع الأيقونة بنجاح' });
      refetch();
      setModal({ id: 0, name: null });
      setIcon(null);
      setLoading(false);
    }).catch((_) => {
      console.log(_.response)
      toast({ type: 'is-danger', position: 'center', message: 'خطأ أثناء رفع الأيقونة' });
      setModal({ id: 0, name: null });
      setLoading(false);
    });
  }

  React.useEffect(() => {
    _getIcon();
    if (icon && typeof icon === 'object') {
      let reader = new FileReader();
      reader.onload = (data) => setIconData(data.target.result);
      reader.readAsDataURL(icon);
    }
  }, [icon, modal]);

  return (
    <div className={`modal ${modal ? 'is-active' : ''}`}>
      <div className='modal-background' onClick={() => setModal({ id: 0, name: null })}></div>
      <div className='modal-card'>
        <header className='modal-card-head'>
          <p className='modal-card-title'>أيقونة القسم {category.name}</p>
          <a className='delete' aria-label='close' onClick={() => setModal({ id: 0, name: null })}></a>
        </header>
        <div className='modal-card-body'>
          <div className='file is-boxed is-centered'>
            <label className='file-label'>
              <input className='file-input' type='file' name='icon' onChange={ _selectIcon } />
              <span className='file-cta'>
                <span className='file-label'>
                  اختر الأيقونة
                </span>
              </span>
            </label>
          </div>
          <ShowIcon />
        </div>
        <footer className='modal-card-foot'>
          <a type='button' className='button' data-bs-dismiss='modal' onClick={() => setModal({ id: 0, name: null })}>اغلاق</a>
          <button type='submit' className='button is-danger' onClick={ _submit } disabled={loading}>حفظ</button>
        </footer>
      </div>
    </div>
  )
}

export default CategoryIcon;
